import { FormControl } from "@angular/forms";

/**
 * Classe model pour les données saisie dans le composant SIT PRO
 */
export class SitProModel {

    /**
     * Réponse à la question vous êtes actuellement (situation professionnelle)
     * Valeurs possibles : 
     * - ACT_INCONNUE
     * - ETU
     * - EBO
     * - STG_RSA
     * - CONGE_MATPAT
     */
    public codeSituation: string;

    /**
     * Indique si le code situation est défini
     */
    public isCodeSituationDefini = false;

    /**
     * Réponse à la question etes vous en activité
     */
    public enActivite: boolean;

    /**
     * Indique si anActivite est défini
     */
    public isEnActiviteDefini = false;

    /**
     * Réponse à la question etes vous au chomage
     */
    public auChomage: boolean;

    /**
     * indique si auChomage est défini
     */
    public isAuChomageDefini = false;

    /**
     * Réponse à la question sur l'indemnité
     */
    public indemnite: boolean;

    /**
     * Indique si indemnite est défini
     */
    public isIndemniteDefini = false;

    /**
     * Constructeur
     */
    constructor() { }
}

export class SitProForm {
    questionSitPro?:FormControl<string>;
    questionActPro?:FormControl<string>;
    questionChomage?:FormControl<string>;
    questionIndemnite?:FormControl<string>;
}
